// extracted by mini-css-extract-plugin
export default {"policy":"Acceptance_policy__iZPrY","wrapper":"Acceptance_wrapper__pH4PQ","addr":"Acceptance_addr__DRR1d","points":"Acceptance_points__kfwMB","rules":"Acceptance_rules__iFZ-c"};